module.exports = __webpack_public_path__ + "img/board.b4fd2c38.png";